module.exports = __webpack_public_path__ + "static/media/Elasticsearch.83445855.png";